import React from 'react';
import styled from 'styled-components';
import { Domain } from '../../../types/globalTypes';
import { device } from '../../../constants';
import { IndustryItem } from './IndustryItem';
import { getIndustryIcons } from '../../home/partials/IndustryCard/data';

interface IndustryListProps {
  industries: Domain[];
}

const IndustryList = ({ industries }: IndustryListProps) => {
  const icons = getIndustryIcons();
  return (
    <IndustryListWrapper>
      {industries.map(industry => (
        <IndustryItem
          key={industry._id}
          industry={industry}
          projectName={industry.ProjectName}
          icon={icons[industry?.Name.trim()] || icons.default}
        />
      ))}
    </IndustryListWrapper>
  );
};
const IndustryListWrapper = styled.div`
  margin-top: 60px;
  display: grid;
  gap: 40px 22px;
  grid-template-columns: repeat(3, 1fr);
  @media screen and (${device.md}) {
    margin-top: 40px;
  }
  @media screen and (${device.sm}) {
    margin-top: 20px;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;
export { IndustryList };
